import { render, staticRenderFns } from "./SentimentCyclicalityYear.vue?vue&type=template&id=6b991ca0&scoped=true"
import script from "./SentimentCyclicalityYear.vue?vue&type=script&lang=js"
export * from "./SentimentCyclicalityYear.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b991ca0",
  null
  
)

export default component.exports